import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import styles from './index.module.scss';

const ClientManagement = () => {
    return (
        <div className={styles['client-management']}>
            <Heading type={HEADING_TYPES['1']}>
                Client Management
            </Heading>
        </div>
    );
};

export {ClientManagement as TestableClientManagement};
export default ClientManagement;
